import { useQuery } from '@tanstack/react-query'
import { getProfile } from '../../services/ProfileService'
import { AuthQueryKey } from '@/modules/auth/keys'
import { UseBaseQueryOptions } from '@/core/api/type'
import { GetOperatorMeResponse } from '@/modules/operator/type'
import { GetAdminMeResponse } from '@/modules/admin/type'

export default function useQueryProfile(
	props?: UseBaseQueryOptions<GetAdminMeResponse & GetOperatorMeResponse>,
) {
	return useQuery({
		queryKey: [AuthQueryKey.Profile],
		queryFn: getProfile,
		staleTime: Infinity,
		refetchOnWindowFocus: false,
		...props,
	})
}
